import { Demosuche } from "components/page-components/Ausschreibungsdienste"
import { EmailCoursesSignupModule } from "components/page-components/Signup-Modules"
import React from "react"

export const NoticePageDemosearch = ({ ZoneOfRequest = 0 }) => {
  return (
    <div id="notice-page-offerings">
      <div
        data-nosnippet
        className="section py-6 has-background-mitternachtsblau"
      >
        <p className="has-text-centered has-text-white title is-3 is-size-4-mobile pt-6 mb-3">
          Sie suchen passende Aufträge für Ihre Firma?
        </p>
        <div className="columns is-centered">
          <div className="column is-4">
            <p className="has-text-centered has-text-white pb-5">
              Egal ob Bau-, Liefer-, oder Dienstleistungen, in unserer
              B_I&nbsp;ausschreibungsdatenbank finden Sie garantiert zahlreiche{" "}
              {ZoneOfRequest === 4 ? "Aufträge" : "Ausschreibungen"} auch für
              Ihre Firma.
            </p>
          </div>
        </div>
        <Demosuche withoutCTA />
        <p className="has-text-centered has-text-white  pb-6 pt-4">
          Aktuell{" "}
          <span className="has-text-weight-bold">
            mehr als 10.000
            {/* {total_number_of_notices.toLocaleString("de-DE")} */}
          </span>{" "}
          {ZoneOfRequest === 4 ? "Aufträge" : "Ausschreibungen"} verfügbar.
        </p>
      </div>
      <div className="section is-clipped">
        <div className="my-6">
          <EmailCoursesSignupModule />
        </div>
      </div>
    </div>
  )
}
